import { RouteConfig } from "vue-router";

//communication
import CampaignList from "@/views/Communication/Campaign/CampaignList.vue";
import CampaignCreate from "@/views/Communication/Campaign/CampaignCreate.vue";
import CampaignJobs from "@/views/Communication/Campaign/CampaignJobs.vue";
import JobMonitoring from "@/views/Communication/Campaign/JobMonitoring.vue";

import CommunicationIndex from "@/views/Communication/CommunicationIndex.vue";
import UrlShortener from "@/views/Communication/UrlShortener.vue";
import Extractor from "@/views/Extractor.vue";
import EmailTemplateList from "@/views/Communication/EmailTemplate/EmailTemplateList.vue";
import EmailTemplateForm from "@/views/Communication/EmailTemplate/EmailTemplateForm.vue";

import SmsTemplateList from "@/views/Communication/SmsTemplate/SmsTemplateList.vue";
import SmsTemplateForm from "@/views/Communication/SmsTemplate/SmsTemplateForm.vue";

//prosepection
import ClientsView from "@/views/Sell/ClientsView.vue";
import HandShakeList from "@/views/Sell/HandShakeList.vue";
import SellDashboard from "@/views/Sell/SellDashboard.vue";
import HandShakeForm from "@/views/Sell/HandShakeForm.vue";
import DetailsClientView from "@/views/Sell/DetailsClientView.vue";
import CompanyView from "@/views/Sell/CompanyView.vue";
import DetailsCompanyView from "@/views/Sell/DetailsCompanyView.vue";
import VoucherManager from "@/views/Income/VoucherManager.vue";
import CotationSearch from "@/views/Income/CotationSearch.vue";
import CotationList from "@/views/Income/CotationList.vue";
import QueryList from "@/views/Todo/QueryList.vue";

const prefix = "/crm";
const crmRoutes: Array<RouteConfig> = [
  {
    path: "/",
    name: "crm-index",
    component: () => import("@/views/CRM/Index.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL', 'ROLE_VIA']},
  },

  //prospection
  {
    path: "/handshake/list",
    name: "handshake-list",
    component: HandShakeList,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  {
    path: "/handshake/form/:uuid?/:clientId?/:entrepriseId?",
    name: "handshake-form",
    component: HandShakeForm,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/prospects",
    name: "prospection-clients",
    component: ClientsView,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  {
    path: "/prospects/:id",
    name: "details-clients",
    component: DetailsClientView,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/entreprise",
    name: "company",
    component: CompanyView,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/entreprise/:id",
    name: "detail-company",
    component: DetailsCompanyView,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  //communication
  {
    path: "/sms",
    name: "sms",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/Communication/Sms/SmsSender.vue"
      ),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/email/template/list",
    name: "email-template-list",
    component: EmailTemplateList,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  {
    path: "/email/template/form/:uuid?",
    name: "email-template-form",
    component: EmailTemplateForm,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  {
    path: "/template/sms/list",
    name: "sms-template-list",
    component: SmsTemplateList,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/template/sms/form/:uuid?",
    name: "sms-template-form",
    component: SmsTemplateForm,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/campaign/list",
    name: "campaign-list",
    component: CampaignList,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/campaign/create/:id?",
    name: "campaign-create",
    component: CampaignCreate,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/campaign/:id/jobs",
    name: "campaign-jobs",
    component: CampaignJobs,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    // Suivi des envois (ex « Jobs orphelins ») : TOUS les jobs email/SMS/WhatsApp du
    // notifier, avec filtres campagne/canal/statut et actions annuler/relancer.
    path: "/envois/suivi",
    name: "job-monitoring",
    component: JobMonitoring,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  {
    // Ancienne URL conservée (favoris) -> même page.
    path: "/jobs/orphans",
    name: "orphan-jobs",
    component: JobMonitoring,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  //chat
  // Chat Whatsapp = nouvelle console (ex chat-console). L'ancienne vue (ChatIndex)
  // reste accessible sous /old/crm/chat-whatsapp (route chat-whatsapp-old, definie
  // dans router/index.ts car non prefixee par /crm), car elle porte encore des
  // fonctionnalites pas migrees (onglets, documents, notes, actions supplementaires).
  {
    path: "/chat-whatsapp",
    name: "chat-whatsapp",
    component: () => import("@/views/Chat/Console/ChatConsole.vue"),
    props: (route: any) => ({
      ...route.query,
    }),
    meta: {requiredRoles: ['ROLE_COMMERCIAL', 'ROLE_MANAGER']},
  },
  // Compat : anciens liens/bookmarks vers /crm/chat-console -> chat-whatsapp
  {
    path: "/chat-console",
    name: "chat-console",
    redirect: { name: "chat-whatsapp" },
  },
  {
    path: "/chat-analytics",
    name: "chat-analytics",
    component: () => import("@/views/Chat/Analytics.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL', 'ROLE_MANAGER']},
  },
  {
    path: "/chat-flows",
    name: "chat-flows",
    component: () => import("@/views/Chat/Flows.vue"),
    meta: {requiredRoles: ['ROLE_MANAGER', 'ROLE_ADMIN']},
  },
  {
    path: "/chat-routing",
    name: "chat-routing",
    component: () => import("@/views/Configuration/ChatRouting.vue"),
    meta: {requiredRoles: ['ROLE_MANAGER', 'ROLE_ADMIN']},
  },
  {
    path: "/whatsapp/template",
    name: "whatsapp-template",
    component: () => import("@/views/Chat/Whatsapp/Templates/TemplateList.vue"),
    props: (route: any) => ({
      ...route.query,
    }),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/url/shortener",
    name: "url-shortener",
    component: UrlShortener,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },
  {
    path: "/extractor",
    name: "extractor",
    component: Extractor,
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/coupon/manager",
    name: "coupon-manager",
    component: VoucherManager,
    meta: {requiredRoles: ['ROLE_PRODUCTEUR', 'ROLE_MARKETING']},
  },

  {
    path: "/cotation/search",
    name: "cotation-search",
    component: CotationList,
    props: (route: any) => ({
      ...route.query,
    }),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/todo/query/list",
    name: "todo-query-list",
    component: QueryList,
    meta: {requiredRoles: ['ROLE_MANAGER', 'ROLE_VIA']},
  },

  // Dashboard
  {
    path: "/",
    name: "crm-v2-index",
    component: () => import("@/views/CRM/Index.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  // activities (calendar)

  {
    path: "/activities",
    name: "crm-v2-activities",
    component: () => import("@/views/CRM/Activities.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  // Contact ->  infos contact + historique activités
  {
    path: "/contacts",
    name: "crm-v2-contacts",
    component: () => import("@/views/CRM/Contacts/ListContacts.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/contacts/:id",
    name: "crm-v2-contact",
    component: () => import("@/views/CRM/Contacts/ContactView.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  // entreprise -> infos entreprise + contacts liés + historique activités

  {
    path: "/companies",
    name: "crm-v2-companies",
    component: () => import("@/views/CRM/Companies/ListCompanies.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  {
    path: "/companies/:id",
    name: "crm-v2-company",
    component: () => import("@/views/CRM/Companies/CompanyView.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  // Pipeline -> informations + historique activités + create activity

  {
    path: "/pipeline",
    name: "crm-v2-pipeline",
    component: () => import("@/views/CRM/PipelineView.vue"),
    meta: {requiredRoles: ['ROLE_MARKETING', 'ROLE_COMMERCIAL']},
  },

  // Deals -> informations + historique activités + create activity

  {
    path: "/deal/:id",
    name: "crm-v2-deal",
    component: () => import("@/views/CRM/DealView.vue"),
    meta: {requiredRoles: ['ROLE_COMMERCIAL']},
  },

  // Exports

  {
    path: "/exports",
    name: "crm-v2-exports",
    component: () => import("@/views/CRM/ExportProspects.vue"),
    meta: {requiredRoles: ['ROLE_ADMIN']},
  },
];
crmRoutes.forEach((route) => {
  route.path = prefix + route.path;
});
export default crmRoutes;
